module.exports = __webpack_public_path__ + "img/Klipsu-III.cdb4d901.png";